import React from 'react';

interface MailIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const MailIcon = ({ width = 16, height = 16, fill = 'black' }: MailIconProps) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.2008 4.25L8.74238 8.525C8.5201 8.67007 8.26309 8.74701 8.00078 8.74701C7.73847 8.74701 7.48147 8.67007 7.25918 8.525L0.800781 4.25M2.24078 2H13.7608C14.5561 2 15.2008 2.67157 15.2008 3.5V12.5C15.2008 13.3284 14.5561 14 13.7608 14H2.24078C1.44549 14 0.800781 13.3284 0.800781 12.5V3.5C0.800781 2.67157 1.44549 2 2.24078 2Z" stroke="#3F4246" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default MailIcon;
